var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topbar"},[_c('b-row',{attrs:{"align-h":"between","align-v":"stretch"}},[_c('b-col',[_c('KTQuickUser')],1)],1),(_vm.isNewLayout)?[_c('KTMenuOptionsMore')]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }